module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bEPRd"))).then(() => parcelRequire('8NFma'));